<div class="dc-loading on" [class.on]="showLoading" [style.backgroundColor]="backgroundColor">
  <div class="dc-spinner"></div>
</div>
<ng-content></ng-content>
